/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Hero_TitleInputs */

const en_help_hero_title = /** @type {(inputs: Help_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How can we help?`)
};

const pl_help_hero_title = /** @type {(inputs: Help_Hero_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W czym możemy pomóc?`)
};

/**
* | output |
* | --- |
* | "How can we help?" |
*
* @param {Help_Hero_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_hero_title = /** @type {((inputs?: Help_Hero_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Hero_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_hero_title(inputs)
	return en_help_hero_title(inputs)
});